import * as angular from 'angular';
import './relevant-articles.scss';
import { Component } from 'ng-metadata/core';


/**
 * @ngdoc directive
 * @name mwMediaSourceDocumentRelevantArticlesComponent
 * @module mw.components.contentDocuments
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 */

@Component({
    selector: 'mw-media-source-document-relevant-articles',
    template: `
        <ng-transclude></ng-transclude>
    `,
    legacy: {
        transclude: true
    }
})
export class MediaSourceDocumentRelevantArticlesComponent {

}


// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/relevant-articles/relevant-articles.component.ts